var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sections),function(section){return _c('ContentSection',_vm._b({},'ContentSection',section,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }